import React from 'react';
import { ProductMockup } from '../ProductMockup';
import { PurchaseButton } from '../PurchaseButton';
export function Hero() {
  return <section id="top" className="bg-charcoal text-ivory" data-id="element-97" data-mp="7x1jr85n692s">
      <div className="mx-auto grid max-w-site gap-x-14 gap-y-8 px-5 pb-16 pt-12 md:px-8 lg:grid-cols-[1fr_1.1fr] lg:pb-24 lg:pt-20" data-id="element-98" data-mp="cvl79czvvsx9">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-99" data-mp="hwilxfloq4u0">
          <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-copper" data-id="element-100" data-mp="mutvrqbzcfc8">Visual Diesel Diagnostic Reference</p>
          <h1 className="mt-5 font-display text-[46px] font-bold uppercase leading-[0.98] tracking-[0.01em] sm:text-[58px] lg:text-[70px]" data-id="element-101" data-mp="qu2qaxeugh8u">
            Diesel
            <br data-id="element-102" data-mp="10lyqce0hqhfp" />
            Fault Atlas
          </h1>
          <p className="mt-6 max-w-[480px] font-display text-[24px] font-semibold leading-snug text-ivory lg:text-[28px]" data-id="element-103" data-mp="10knpon2cdpst">
            A clearer path from symptom to diagnosis.
          </p>
        </div>

        <figure className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-104" data-mp="1ahikovzep82c">
          <div className="rounded-[6px] border border-white/[0.06] bg-graphite px-6 pb-4 pt-8 sm:px-10" data-id="element-105" data-mp="9p45a28vjzal">
            <ProductMockup eager className="mx-auto max-w-[560px]" data-id="element-106" data-mp="4qsspjr73aoo" />
          </div>
          <figcaption className="mt-3 text-[14px] text-mist" data-id="element-107" data-mp="3vvj2q093namw">Digital reference collection. No physical books or diagnostic equipment are shipped.</figcaption>
        </figure>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-108" data-mp="sd90glbgubxs">
          <p className="max-w-[520px] text-[17px] leading-[1.65] text-mist lg:text-[18px]" data-id="element-109" data-mp="nfhc21a157yc">
            Organize your next diesel diagnostic investigation with visual workflows, testing guides, decision trees, and practical workshop
            references. Explore six diagnostic volumes and five supporting resources in one digital collection.
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-7" data-id="element-110" data-mp="1b638swel35t1">
            <PurchaseButton mode="scroll" data-id="element-111" data-mp="16cikjw2slq71" />
            <a href="#collection" className="inline-flex min-h-[44px] items-center text-[16px] font-semibold text-ivory underline decoration-copper decoration-2 underline-offset-[7px] transition-colors duration-150 ease-out hover:text-copper" data-id="element-112" data-mp="30m7747jd1075">
              Explore What’s Included
            </a>
          </div>
          <p className="mt-8 border-t border-white/10 pt-5 font-mono text-[12px] uppercase leading-relaxed tracking-[0.08em] text-mist" data-id="element-113" data-mp="2vtmfncnxez6s">
            6 diagnostic volumes · 5 included bonuses · Visual guides and workshop resources
          </p>
        </div>
      </div>
    </section>;
}